import { render, staticRenderFns } from "./PortPolicy.vue?vue&type=template&id=714c283a&scoped=true"
import script from "./PortPolicy.vue?vue&type=script&lang=ts"
export * from "./PortPolicy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714c283a",
  null
  
)

export default component.exports